/* eslint-disable react/display-name */
import {
  Button,
  Col,
  ContentBody,
  ContentHeader,
  Drawer,
  Dropdown,
  Input,
  Menu,
  MenuItem,
  RangeDatePicker,
  Row,
  Select,
  Table
} from '../../core/components'
import { Link } from 'react-router-dom'
import { routesConfig } from '../../core/configs/routes'
import {
  CheckOutlined,
  DownOutlined,
  EditOutlined,
  FilterOutlined,
  PlusOutlined
} from '@ant-design/icons'
import { dateTimeFormat } from '../../utils/format/dateTimeFormat'
import { ChangeEvent, useEffect, useMemo, useState } from 'react'
import useOpportunities from '../../services/queries/opportunity/useOpportunities'
import { CustomerType, OpportunityFilter, Pagination } from '../../entities'
import { Select as AntdSelect } from 'antd'
import useOpportunityConcepts from '../../services/queries/opportunity/useOpportunityConcepts'
// import useOpportunityCampaigns from '../../services/queries/opportunity/useOpportunityCampaigns'
import useOpportunityEvents from '../../services/queries/opportunity/useOpportunityEvents'
import useApproveOrder from '../../services/mutations/useApproveOrder'

const filterDefaultValue = {
  search: '',
  concept: '',
  event: '',
  // campaign: '',
  createdAt: {
    startDate: '',
    endDate: ''
  }
}

const { Option } = AntdSelect

export const OpportunitiesPage = () => {
  const [pagination, setPagination] = useState<Pagination>({
    page: 1,
    limit: 10
  })
  const [showFilter, setShowFilter] = useState<boolean>(false)

  const [filters, setFilters] = useState<OpportunityFilter>(filterDefaultValue)
  const [filterState, setFilterState] =
    useState<OpportunityFilter>(filterDefaultValue)

  const { data, isLoading, isFetching, isPreviousData } = useOpportunities({
    ...pagination,
    filters
  })
  const { data: concepts, isLoading: isConceptsLoading } =
    useOpportunityConcepts({
      ...pagination
    })
  // const { data: campaigns, isLoading: isCampaignsLoading } =
  //   useOpportunityCampaigns({
  //     ...pagination
  //   })
  const { data: events, isLoading: isEventsLoading } = useOpportunityEvents({
    ...pagination
  })

  const { mutate: approveOrder } = useApproveOrder()

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setFilterState((prev: OpportunityFilter) => ({
      ...prev,
      search: e.target.value.toUpperCase()
    }))
  }

  const handlePagination = (page: number, limit: number) => {
    setPagination({ page, limit })
  }

  const handleReset = () => {
    setFilterState(filterDefaultValue)
    setFilters(filterDefaultValue)
  }

  useEffect(() => {
    if (filterState.search === '')
      setFilters((prev) => ({ ...prev, search: '' }))
  }, [filterState.search])

  // const menu = (obj: any) => {
  //   return (
  //     <Menu>
  //       {obj.situation.id === '10' && (
  //         <Link to={routesConfig.oportunities.oportunity.list + `/${obj.id}`}>
  //           <MenuItem icon={<EditOutlined />}>Editar</MenuItem>
  //         </Link>
  //       )}
  //       {obj.situation.id === '10' && (
  //         <Button onClick={() => approveOrder(obj.orderId)}>
  //           <MenuItem icon={<CheckOutlined />}>Aprovar</MenuItem>
  //         </Button>
  //       )}
  //     </Menu>
  //   )
  // }

  const columns = useMemo(
    () => [
      {
        title: 'Nº Oportunidade',
        dataIndex: 'id',
        key: 'id',
        render: (value: any, row: any) => {
          return (
            <Link
              to={
                routesConfig.oportunities.oportunity.details +
                `/${row.id}/detalhes`
              }
            >
              {value}
            </Link>
          )
        }
      },
      {
        title: 'Cliente',
        dataIndex: 'customer',
        render: (value: CustomerType) => (value ? value.name : '')
      },
      {
        title: 'Evento (Origem do Contato)',
        dataIndex: 'event',
        key: 'event',
        render: (value: any) => {
          return value.name
        }
      },
      // {
      //   title: 'Campanha',
      //   dataIndex: 'campaign',
      //   key: 'campaign',
      //   render: (value: any) => {
      //     return value.name
      //   }
      // },
      {
        title: 'Conceito',
        dataIndex: 'concept',
        key: 'concept',
        render: (value: any) => {
          return value.name
        }
      },
      {
        title: 'Data/Hora',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (value: string) => (value ? dateTimeFormat(value) : null)
      },
      {
        title: 'Ações',
        dataIndex: '#',
        width: 100,
        render: (value: any, obj: any) => (
          <Dropdown
            disabled={obj?.situation?.id !== '10'}
            overlay={() => {
              return (
                <Menu>
                  {obj?.situation?.id === '10' && (
                    <Link
                      to={
                        routesConfig.oportunities.oportunity.list + `/${obj.id}`
                      }
                    >
                      <MenuItem icon={<EditOutlined />}>Editar</MenuItem>
                    </Link>
                  )}
                  {obj?.situation?.id === '10' && (
                    <MenuItem
                      onClick={() => approveOrder(obj.orderId)}
                      icon={<CheckOutlined />}
                    >
                      Aprovar
                    </MenuItem>
                  )}
                </Menu>
              )
            }}
          >
            <Button disabled={obj?.situation?.id !== '10'}>
              <DownOutlined />
            </Button>
          </Dropdown>
        )
      }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const handleShowFilter = () => {
    setShowFilter((prev: boolean) => !prev)
  }

  const handleClear = (key: string) => {
    setFilters((prev) => ({ ...prev, [key]: '' }))
    setFilterState((prev) => ({ ...prev, [key]: '' }))
  }

  const handleDateClear = () => {
    console.log('clearDate')
    setFilters((prev) => ({
      ...prev,
      createdAt: { startDate: '', endDate: '' }
    }))
    setFilterState((prev) => ({
      ...prev,
      createdAt: { startDate: '', endDate: '' }
    }))
  }
  return (
    <>
      <ContentHeader>Oportunidades</ContentHeader>
      <ContentBody>
        <Link to={routesConfig.oportunities.oportunity.create}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            style={{
              marginBottom: 30
            }}
          >
            Novo
          </Button>
        </Link>
        <Row style={{ marginBottom: 10 }}>
          <Col>
            <Input
              allowClear
              value={filterState.search}
              placeholder="Pesquisar cliente ..."
              style={{ width: '385px', marginBottom: 20 }}
              onChange={(e) => handleSearch(e)}
              onPressEnter={() => setFilters(filterState)}
            />
          </Col>
          <Col>
            <Button
              htmlType="submit"
              type="primary"
              style={{ width: 100, marginLeft: 20 }}
              onClick={() => setFilters(filterState)}
            >
              Procurar
            </Button>
            <Button style={{ marginLeft: 10 }} onClick={handleReset}>
              Reiniciar
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              onClick={handleShowFilter}
              icon={<FilterOutlined />}
            >
              Filtros
            </Button>
          </Col>
        </Row>
        <Table
          loading={(isLoading || isFetching) && isPreviousData}
          dataSource={data?.data}
          columns={columns}
          pagination={{
            pageSize: pagination.limit,
            current: pagination.page,
            total: data?.total,
            onChange: (page, limit) => handlePagination(page, limit || 10)
          }}
          // onChange={handleTableChange}
          bordered
          rowKey={(row) => row.id}
        />
        <Drawer
          title="Filtros"
          width={520}
          closable={false}
          onClose={handleShowFilter}
          visible={showFilter}
          footer={
            <div
              style={{
                textAlign: 'right',
                paddingBottom: 30,
                paddingTop: 30
              }}
            >
              <Button
                onClick={() => {
                  handleReset()
                  handleShowFilter()
                }}
                style={{ marginRight: 8 }}
              >
                Reiniciar
              </Button>
              <Button
                onClick={() => {
                  setFilters(filterState)
                  handleShowFilter()
                }}
                type="primary"
              >
                Aplicar
              </Button>
            </div>
          }
        >
          <Row>
            <Col span={24}>
              <Select
                label="Evento"
                placeholder="Selecione..."
                allowClear
                onClear={() => handleClear('event')}
                loading={isEventsLoading}
                value={filterState?.event || null}
                onSelect={(event) =>
                  setFilterState((prev) => ({
                    ...prev,
                    event
                  }))
                }
              >
                {events?.data?.map((event) => (
                  <Option key={event.id} value={event.id}>
                    {`${event.name}`}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>
          {/* <Row>
            <Col span={24}>
              <Select
                label="Campanha"
                placeholder="Selecione..."
                allowClear
                loading={isCampaignsLoading}
                onClear={() => handleClear('campaign')}
                value={filterState?.campaign || null}
                onSelect={(campaign) =>
                  setFilterState((prev) => ({
                    ...prev,
                    campaign
                  }))
                }
              >
                {campaigns?.data?.map((campaign) => (
                  <Option key={campaign.id} value={campaign.id}>
                    {`${campaign.name}`}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row> */}
          <Row>
            <Col span={24}>
              <Select
                label="Conceito"
                placeholder="Selecione..."
                allowClear
                loading={isConceptsLoading}
                onClear={() => handleClear('concept')}
                value={filterState?.concept || null}
                onSelect={(concept) =>
                  setFilterState((prev) => ({
                    ...prev,
                    concept
                  }))
                }
              >
                {concepts?.data?.map((concept) => (
                  <Option key={concept.id} value={concept.id}>
                    {`${concept.name}`}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <RangeDatePicker
                label="Data Realização"
                format={'DD/MM/YYYY'}
                // onOk={onOk}
                allowClear
                placeholder={['Data Inicial', 'Data Final']}
                onClear={handleDateClear}
                onChange={(e: any) => {
                  if (!e) handleDateClear()
                  setFilterState((prev) => ({
                    ...prev,
                    createdAt: {
                      startDate: e?.[0] || '',
                      endDate: e?.[1] || ''
                    }
                  }))
                }}
              />
            </Col>
          </Row>
        </Drawer>
      </ContentBody>
    </>
  )
}
